module.exports = __webpack_public_path__ + "img/no-one-under-eighteen-emoji.73c32fd3.png";